'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeLeftString = getTimeLeftString;
exports.timeLeft = timeLeft;
exports.isNumber = isNumber;
exports.formatDate = formatDate;
exports.counterCropper = counterCropper;
exports.badgeStatus = badgeStatus;
exports.lowerCaseAllWordsExceptFirstLetters = lowerCaseAllWordsExceptFirstLetters;
exports.capitalizeText = capitalizeText;
exports.labelFieldItem = labelFieldItem;
exports.isEqual = isEqual;
exports.urlPrefixValidation = urlPrefixValidation;
exports.camelCaseToRegular = camelCaseToRegular;
exports.onlyUniqueArray = onlyUniqueArray;
exports.getQueryStringValue = getQueryStringValue;
exports.isEmptyInput = isEmptyInput;
exports.getExtension = getExtension;
exports.fileNameCropper = fileNameCropper;
exports.numberFormat = numberFormat;
exports.isFunction = isFunction;
exports.replaceFirstSpace = replaceFirstSpace;
exports.sortByKeyAlphabetically = sortByKeyAlphabetically;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = {
  config: _config2.default
};

function getTimeLeftString(date) {
  var endDate = (0, _moment2.default)(date);
  var now = (0, _moment2.default)();

  if (endDate.isValid()) {
    var left = _moment2.default.duration(endDate.diff(now));

    var daysLeft = Math.floor(left.asDays());
    var hoursLeft = Math.floor(left.asHours());
    var minutesLeft = Math.floor(left.asMinutes());

    if (daysLeft > 0) {
      return "".concat(daysLeft, " ").concat(daysLeft === 1 ? 'Day' : 'Days');
    }

    if (hoursLeft) {
      return "".concat(hoursLeft, " ").concat(hoursLeft === 1 ? 'hour' : 'hours');
    }

    return "".concat(minutesLeft, " ").concat(minutesLeft === 1 ? 'minute' : 'minutes');
  }

  return '';
}

function timeLeft(date) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'minutes';
  return (0, _moment2.default)(date).diff((0, _moment2.default)(), unit);
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function formatDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD.MM.YYYY';

  if (!date) {
    return null;
  }

  var dateUTC = _moment2.default.utc(date);

  return (0, _moment2.default)(dateUTC).local().format(format);
}

function counterCropper(number) {
  function splice(str, start, rem, subStr) {
    return str.slice(0, start) + subStr + str.slice(start + Math.abs(rem));
  }

  function formatString(str, dif, suffix) {
    str = str.slice(0, str.length - dif);
    return splice(str, str.length - 1, 0, '.').replace('.0', '') + suffix;
  }

  if (number) {
    var str = String(number);
    return number >= 1000000000 && formatString(str, 8, 'B') || number >= 1000000 && formatString(str, 5, 'M') || number >= 1000 && formatString(str, 2, 'K') || str;
  }

  return '0';
}

function badgeStatus(date) {
  if ((0, _moment2.default)(date).isAfter((0, _moment2.default)())) {
    return 'success';
  }

  if ((0, _moment2.default)(date).isBefore((0, _moment2.default)())) {
    return 'error';
  }

  return 'default';
}

function lowerCaseAllWordsExceptFirstLetters(status) {
  return status.charAt(0) + status.substr(1).toLowerCase();
}

function capitalizeText() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return text.split(splitter).map(function (item) {
    return lowerCaseAllWordsExceptFirstLetters(item);
  }).join(' ');
}

function labelFieldItem(fieldName) {
  return fieldName.split(/(?=[A-Z])/).map(function (key, i) {
    return i > 0 ? key.toLowerCase() : key.charAt(0).toUpperCase() + key.substr(1);
  }).join(' ');
}

function isEqual(value, other) {
  var type = Object.prototype.toString.call(value);
  if (type !== Object.prototype.toString.call(other)) return false;
  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;
  var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
  var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
  if (valueLen !== otherLen) return false;

  function compare(item1, item2) {
    var itemType = Object.prototype.toString.call(item1);

    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2)) return false;
    } else {
      if (itemType !== Object.prototype.toString.call(item2)) return false;

      if (itemType === '[object Function]') {
        if (item1.toString() !== item2.toString()) return false;
      } else if (item1 !== item2) return false;
    }
  }

  if (type === '[object Array]') {
    for (var i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false;
    }
  } else {
    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        if (compare(value[key], other[key]) === false) return false;
      }
    }
  }

  return true;
}

function urlPrefixValidation(url) {
  if (url && !url.match(/^[a-zA-Z]+:\/\//)) return url.padStart(url.length + 8, 'https://');
  return url || '';
}

function camelCaseToRegular(text) {
  var result = text.replace(/([A-Z])/g, ' $1');
  var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
} // Usage example:
// [1,2,1,3,4,4,5].filter( onlyUnique ) => [1, 2, 3, 4, 5]


function onlyUniqueArray(value, index, self) {
  return self.indexOf(value) === index;
}

function getQueryStringValue(key) {
  return key ? decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1')) : false;
}

function isEmptyInput(notRenderOnEmpty, value) {
  return notRenderOnEmpty && !value;
}

function getExtension(filename) {
  var parts = filename.split('.');
  return parts[parts.length - 1];
}

function fileNameCropper() {
  var initialName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
  var initialNameLength = initialName.length;
  var extension = getExtension(initialName) || '';
  var name = initialName.replace(extension, '');
  name = initialNameLength > maxLength ? name.substring(0, maxLength - 3) + '...' : name;
  return {
    croppedName: name,
    croppedNameWithExtension: name + extension
  };
}
/** *
  number - number
  decimals - count of characters after decimal
  dec_point - symbol of decimal
  separator - separator of thousandths
  example - numberFormat(1234567, 3, '.', ',') === 1.234.567,000
** */


function numberFormat(number, decimals, dec_point, separator) {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number;
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  var sep = typeof separator === 'undefined' ? ',' : separator;
  var dec = typeof dec_point === 'undefined' ? '.' : dec_point;
  var s = '';

  var toFixedFix = function toFixedFix(n, prec) {
    var k = Math.pow(10, prec);
    return '' + (Math.round(n * k) / k).toFixed(prec);
  }; // Fixing bug in IE parseFloat(0.55).toFixed(0) = 0;


  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');

  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }

  return s.join(dec);
}

function isFunction(obj) {
  return !!(obj && obj.constructor && obj.call && obj.apply);
}

function replaceFirstSpace(str) {
  var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 's ';
  return str.replace(/\s/, end);
}

function sortByKeyAlphabetically(array, key) {
  array.sort(function (a, b) {
    var textA = a[key].toUpperCase();
    var textB = b[key].toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });
  return array;
}